import React, { useState, useEffect } from 'react';
import ReactTooltip from "react-tooltip";
import './styles/navbar.css';
import { NavLink, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouseChimney, faCircleQuestion, faBasketShopping, faHeadset, faBell, faUser, faBars, faBarsStaggered, faMeteor } from '@fortawesome/free-solid-svg-icons';
import {faBell as faFarBell} from '@fortawesome/free-regular-svg-icons';
import { faDiscord, faTwitter, faYoutube, faInstagram, faTelegram } from '@fortawesome/free-brands-svg-icons';
import { motion } from 'framer-motion';


export default function NavBar({ onLogin, onLogout, userData, locationUI }) {

  const [toggleMenu, setToggleMenu] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [toggleNotify, setToggleNotify] = useState(false);

  const toggleNav = () => {
    setToggleMenu(!toggleMenu);
  }
  const toggleNot = () => {
    setToggleNotify(!toggleNotify);
  }

  useEffect(() => {
    

    const changeWidth = () =>{
      setScreenWidth(window.innerWidth);
    }
    
    window.addEventListener('resize', changeWidth);

    return () => {
    
      window.addEventListener('resize', changeWidth);

    }
  }, [])

  const navigate = useNavigate();

  const PushUrl = (url) => {
    navigate(url);
  }

  if(locationUI === 'BM'){
    return (
      <div className='navbar navbar-main px-3 flex-nowrap'>
        <div className='logo-container'>
          {screenWidth > 750 
            ? <img src={'/img/logo-navbar-11.svg'} className='logo-navbar' alt='Logo Extinction'/>
            : <img src={'/img/logo-min-navbar-19.svg'} className='logo-navbar' alt='Logo Extinction'/>
          }
          
        </div>
        {(toggleMenu || screenWidth > 1249) && (
          <div className=''>
            {screenWidth > 1249
              ? <div className='center-links nav'
            >
              <button className='btn-close' onClick={() => toggleNav()}></button>
              <ul className='navlinks m-0'>
                <NavLink to="/" className={"navlink "} onClick={() => {
                    if(screenWidth < 1249){
                      toggleNav()
                    }
                  }} >
                    <FontAwesomeIcon icon={faHouseChimney} className='me-2'/><span>Home</span>
                </NavLink>
                <NavLink to="/BM" className='navlink active-nav' onClick={() => {
                    if(screenWidth < 1249){
                      toggleNav()
                    }
                  }}>
                    <FontAwesomeIcon icon={faBasketShopping} className='me-2'/><span>Black Market</span>
                </NavLink>
                <NavLink to="/RA" className='navlink' onClick={() => {
                  if(screenWidth < 1249){
                    toggleNav()
                  }
                }}>
                  <FontAwesomeIcon icon={faMeteor} className='me-2'/><span>Radiation Alliance</span>
                </NavLink>
                <NavLink to="/Support" className='navlink' onClick={() => {
                    if(screenWidth < 1249){
                      toggleNav()
                    }
                  }}>
                    <FontAwesomeIcon icon={faHeadset} className='me-2'/><span>Support</span>
                </NavLink>
              </ul>
              {toggleMenu && (
                <>
                  <hr
                      style={{
                          color: '#fff',
                          height: '1px',
                          width: '100%',
                      }}
                  />
                <div className='d-flex align-content-center box-socials'>
                <a href="https://discord.gg/extinctionwars" target={'_blank'} className='social-icons me-3'><FontAwesomeIcon icon={faDiscord}/></a>
                <a href="https://twitter.com/ExtinctionWars" target={'_blank'}className='social-icons me-3'><FontAwesomeIcon icon={faTwitter}/></a>
                <a href="https://www.instagram.com/extinctionwars" target={'_blank'}className='social-icons me-3'><FontAwesomeIcon icon={faInstagram}/></a>
                <a href="https://t.me/WarsExtinction" target={'_blank'}className='social-icons me-3'><FontAwesomeIcon icon={faTelegram}/></a>
                <a href="https://www.youtube.com/channel/UCEQnnrtqR6bqQWXOtzyhLrQ" target={'_blank'} className='social-icons'><FontAwesomeIcon icon={faYoutube}/></a>
              </div>
              </>
              )}
            </div>
            : <motion.div className='center-links nav'
            initial={{x: '-100%'}}
            animate={{x: 0}}
          >
            <button className='btn-close' onClick={() => toggleNav()}></button>
            <ul className='navlinks m-0'>
              <NavLink to="/" className='navlink' onClick={() => {
                  if(screenWidth < 1249){
                    toggleNav()
                  }
                }} >
                  <FontAwesomeIcon icon={faHouseChimney} className='me-2'/><span>Home</span>
              </NavLink>
              <NavLink to="/BM" className='navlink active-nav' onClick={() => {
                  if(screenWidth < 1249){
                    toggleNav()
                  }
                }}>
                  <FontAwesomeIcon icon={faBasketShopping} className='me-2'/><span>Black Market</span>
              </NavLink>
              <NavLink to="/RA" className='navlink' onClick={() => {
                  if(screenWidth < 1249){
                    toggleNav()
                  }
                }}>
                  <FontAwesomeIcon icon={faBasketShopping} className='me-2'/><span>Radiation Alliance</span>
              </NavLink>
              <NavLink to="/Support" className='navlink' onClick={() => {
                  if(screenWidth < 1249){
                    toggleNav()
                  }
                }}>
                  <FontAwesomeIcon icon={faHeadset} className='me-2'/><span>Support</span>
              </NavLink>
            </ul>
            <div className='lenguage'>
              <button className='btn-change-lenguage' style={{backgroundImage: "url(/img/usa-flag.png)"}}>
              </button>
            </div>
            {toggleMenu && (
              <>
                <hr
                    style={{
                        color: '#fff',
                        height: '1px',
                        width: '100%',
                    }}
                />
              <div className='d-flex align-content-center box-socials'>
              <a href="https://discord.gg/extinctionwars" target={'_blank'} className='social-icons me-3'><FontAwesomeIcon icon={faDiscord}/></a>
              <a href="https://twitter.com/ExtinctionWars" target={'_blank'}className='social-icons me-3'><FontAwesomeIcon icon={faTwitter}/></a>
              <a href="https://www.instagram.com/extinctionwars" target={'_blank'}className='social-icons me-3'><FontAwesomeIcon icon={faInstagram}/></a>
              <a href="https://t.me/WarsExtinction" target={'_blank'}className='social-icons me-3'><FontAwesomeIcon icon={faTelegram}/></a>
              <a href="https://www.youtube.com/channel/UCEQnnrtqR6bqQWXOtzyhLrQ" target={'_blank'} className='social-icons'><FontAwesomeIcon icon={faYoutube}/></a>
            </div>
            </>
            )}
          </motion.div>

            }
            <div className='bg-navtoggled' onClick={() => toggleNav()}></div>
          </div>
        )}
        <div className='ui-elements d-flex align-items-center'>
          <div className='notify_box'>
            {toggleNotify
              ? <button className='notify' onClick={() => toggleNot()}><FontAwesomeIcon icon={faBell} size='lg'/></button>
              : <button className='notify' onClick={() => toggleNot()}><FontAwesomeIcon icon={faFarBell} size='lg'/></button>

            }
          </div>
          <div className='accounts-nav d-flex align-items-center'>
            <FontAwesomeIcon icon={faUser} size='2x' className='i-user me-2' onClick={() => PushUrl('/profile')} style={{cursor: 'pointer'}}/>
            <div className='account-info'>
              <p className='m-0'>{userData.username}</p>
              <p data-tip={userData.userBalances.bFullWax} className='m-0 account-balance'>{userData.userBalances.bShortWax} WAXP</p>
              <p data-tip={userData.userBalances.bFullOnyx} className='m-0 account-balance'>{userData.userBalances.bShortOnyx} ONYX</p>
            </div>
            {userData.isConnected 
                ? <button className='btn-login' onClick={() => onLogout(userData.sessionData)}>Logout</button>
                : <button className='btn-login' onClick={onLogin}>Log In</button>
            }
            {toggleMenu
              ? <button className='btn-toggler-nav' onClick={() => toggleNav()}><FontAwesomeIcon icon={faBarsStaggered} size='lg'/></button>
              : <button className='btn-toggler-nav' onClick={() => toggleNav()}><FontAwesomeIcon icon={faBars} size='lg'/></button>
            }
          </div>
        </div>
        <ReactTooltip />
    </div>
    )
  }

  if(locationUI === 'RA'){
    return (
      <div className='navbar navbar-main px-3 flex-nowrap'>
        <div className='logo-container'>
          {screenWidth > 750 
            ? <img src={'/img/logo-navbar-11.svg'} className='logo-navbar' alt='Logo Extinction'/>
            : <img src={'/img/logo-min-navbar-19.svg'} className='logo-navbar' alt='Logo Extinction'/>
          }
          
        </div>
        {(toggleMenu || screenWidth > 1249) && (
          <div className=''>
            {screenWidth > 1249
              ? <div className='center-links nav'
            >
              <button className='btn-close' onClick={() => toggleNav()}></button>
              <ul className='navlinks m-0'>
                <NavLink to="/" className={"navlink "} onClick={() => {
                    if(screenWidth < 1249){
                      toggleNav()
                    }
                  }} >
                    <FontAwesomeIcon icon={faHouseChimney} className='me-2'/><span>Home</span>
                </NavLink>
                <NavLink to="/BM" className='navlink' onClick={() => {
                    if(screenWidth < 1249){
                      toggleNav()
                    }
                  }}>
                    <FontAwesomeIcon icon={faBasketShopping} className='me-2'/><span>Black Market</span>
                </NavLink>
                <NavLink to="/RA" className='navlink active-nav' onClick={() => {
                  if(screenWidth < 1249){
                    toggleNav()
                  }
                }}>
                  <FontAwesomeIcon icon={faMeteor} className='me-2'/><span>Radiation Alliance</span>
                </NavLink>
                <NavLink to="/Support" className='navlink' onClick={() => {
                    if(screenWidth < 1249){
                      toggleNav()
                    }
                  }}>
                    <FontAwesomeIcon icon={faHeadset} className='me-2'/><span>Support</span>
                </NavLink>
              </ul>
              {toggleMenu && (
                <>
                  <hr
                      style={{
                          color: '#fff',
                          height: '1px',
                          width: '100%',
                      }}
                  />
                <div className='d-flex align-content-center box-socials'>
                <a href="https://discord.gg/extinctionwars" target={'_blank'} className='social-icons me-3'><FontAwesomeIcon icon={faDiscord}/></a>
                <a href="https://twitter.com/ExtinctionWars" target={'_blank'}className='social-icons me-3'><FontAwesomeIcon icon={faTwitter}/></a>
                <a href="https://www.instagram.com/extinctionwars" target={'_blank'}className='social-icons me-3'><FontAwesomeIcon icon={faInstagram}/></a>
                <a href="https://t.me/WarsExtinction" target={'_blank'}className='social-icons me-3'><FontAwesomeIcon icon={faTelegram}/></a>
                <a href="https://www.youtube.com/channel/UCEQnnrtqR6bqQWXOtzyhLrQ" target={'_blank'} className='social-icons'><FontAwesomeIcon icon={faYoutube}/></a>
              </div>
              </>
              )}
            </div>
            : <motion.div className='center-links nav'
            initial={{x: '-100%'}}
            animate={{x: 0}}
          >
            <button className='btn-close' onClick={() => toggleNav()}></button>
            <ul className='navlinks m-0'>
              <NavLink to="/" className='navlink' onClick={() => {
                  if(screenWidth < 1249){
                    toggleNav()
                  }
                }} >
                  <FontAwesomeIcon icon={faHouseChimney} className='me-2'/><span>Home</span>
              </NavLink>
              <NavLink to="/BM" className='navlink' onClick={() => {
                  if(screenWidth < 1249){
                    toggleNav()
                  }
                }}>
                  <FontAwesomeIcon icon={faBasketShopping} className='me-2'/><span>Black Market</span>
              </NavLink>
              <NavLink to="/RA" className='navlink active-nav' onClick={() => {
                  if(screenWidth < 1249){
                    toggleNav()
                  }
                }}>
                  <FontAwesomeIcon icon={faBasketShopping} className='me-2'/><span>Radiation Alliance</span>
              </NavLink>
              <NavLink to="/Support" className='navlink' onClick={() => {
                  if(screenWidth < 1249){
                    toggleNav()
                  }
                }}>
                  <FontAwesomeIcon icon={faHeadset} className='me-2'/><span>Support</span>
              </NavLink>
            </ul>
            <div className='lenguage'>
              <button className='btn-change-lenguage' style={{backgroundImage: "url(/img/usa-flag.png)"}}>
              </button>
            </div>
            {toggleMenu && (
              <>
                <hr
                    style={{
                        color: '#fff',
                        height: '1px',
                        width: '100%',
                    }}
                />
              <div className='d-flex align-content-center box-socials'>
              <a href="https://discord.gg/extinctionwars" target={'_blank'} className='social-icons me-3'><FontAwesomeIcon icon={faDiscord}/></a>
              <a href="https://twitter.com/ExtinctionWars" target={'_blank'}className='social-icons me-3'><FontAwesomeIcon icon={faTwitter}/></a>
              <a href="https://www.instagram.com/extinctionwars" target={'_blank'}className='social-icons me-3'><FontAwesomeIcon icon={faInstagram}/></a>
              <a href="https://t.me/WarsExtinction" target={'_blank'}className='social-icons me-3'><FontAwesomeIcon icon={faTelegram}/></a>
              <a href="https://www.youtube.com/channel/UCEQnnrtqR6bqQWXOtzyhLrQ" target={'_blank'} className='social-icons'><FontAwesomeIcon icon={faYoutube}/></a>
            </div>
            </>
            )}
          </motion.div>

            }
            <div className='bg-navtoggled' onClick={() => toggleNav()}></div>
          </div>
        )}
        <div className='ui-elements d-flex align-items-center'>
          <div className='notify_box'>
            {toggleNotify
              ? <button className='notify' onClick={() => toggleNot()}><FontAwesomeIcon icon={faBell} size='lg'/></button>
              : <button className='notify' onClick={() => toggleNot()}><FontAwesomeIcon icon={faFarBell} size='lg'/></button>

            }
          </div>
          <div className='accounts-nav d-flex align-items-center'>
            <FontAwesomeIcon icon={faUser} size='2x' className='i-user me-2' onClick={() => PushUrl('/profile')} style={{cursor: 'pointer'}}/>
            <div className='account-info'>
              <p className='m-0'>{userData.username}</p>
              <p data-tip={userData.userBalances.bFullWax} className='m-0 account-balance'>{userData.userBalances.bShortWax} WAXP</p>
              <p data-tip={userData.userBalances.bFullOnyx} className='m-0 account-balance'>{userData.userBalances.bShortOnyx} ONYX</p>
            </div>
            {userData.isConnected 
                ? <button className='btn-login' onClick={() => onLogout(userData.sessionData)}>Logout</button>
                : <button className='btn-login' onClick={onLogin}>Log In</button>
            }
            {toggleMenu
              ? <button className='btn-toggler-nav' onClick={() => toggleNav()}><FontAwesomeIcon icon={faBarsStaggered} size='lg'/></button>
              : <button className='btn-toggler-nav' onClick={() => toggleNav()}><FontAwesomeIcon icon={faBars} size='lg'/></button>
            }
          </div>
        </div>
        <ReactTooltip />
    </div>
    )
  }

  return (
    <div className='navbar navbar-main px-3 flex-nowrap'>
        <div className='logo-container'>
          {screenWidth > 750 
            ? <img src={'/img/logo-navbar-11.svg'} className='logo-navbar' alt='Logo Extinction'/>
            : <img src={'/img/logo-min-navbar-19.svg'} className='logo-navbar' alt='Logo Extinction'/>
          }
          
        </div>
        {(toggleMenu || screenWidth > 1249) && (
          <div className=''>
            {screenWidth > 1249
              ? <div className='center-links nav'
            >
              <button className='btn-close' onClick={() => toggleNav()}></button>
              <ul className='navlinks m-0'>
                <NavLink to="/" className='navlink active-nav' onClick={() => {
                    if(screenWidth < 1249){
                      toggleNav()
                    }
                  }} >
                    <FontAwesomeIcon icon={faHouseChimney} className='me-2'/><span>Home</span>
                </NavLink>
                <NavLink to="/BM" className='navlink' onClick={() => {
                    if(screenWidth < 1249){
                      toggleNav()
                    }
                  }}>
                    <FontAwesomeIcon icon={faBasketShopping} className='me-2'/><span>Black Market</span>
                </NavLink>
                <NavLink to="/RA" className='navlink' onClick={() => {
                  if(screenWidth < 1249){
                    toggleNav()
                  }
                }}>
                  <FontAwesomeIcon icon={faMeteor} className='me-2'/><span>Radiation Alliance</span>
                </NavLink>
                <NavLink to="/Support" className='navlink' onClick={() => {
                    if(screenWidth < 1249){
                      toggleNav()
                    }
                  }}>
                    <FontAwesomeIcon icon={faHeadset} className='me-2'/><span>Support</span>
                </NavLink>
              </ul>
              {toggleMenu && (
                <>
                  <hr
                      style={{
                          color: '#fff',
                          height: '1px',
                          width: '100%',
                      }}
                  />
                <div className='d-flex align-content-center box-socials'>
                <a href="https://discord.gg/extinctionwars" target={'_blank'} className='social-icons me-3'><FontAwesomeIcon icon={faDiscord}/></a>
                <a href="https://twitter.com/ExtinctionWars" target={'_blank'}className='social-icons me-3'><FontAwesomeIcon icon={faTwitter}/></a>
                <a href="https://www.instagram.com/extinctionwars" target={'_blank'}className='social-icons me-3'><FontAwesomeIcon icon={faInstagram}/></a>
                <a href="https://t.me/WarsExtinction" target={'_blank'}className='social-icons me-3'><FontAwesomeIcon icon={faTelegram}/></a>
                <a href="https://www.youtube.com/channel/UCEQnnrtqR6bqQWXOtzyhLrQ" target={'_blank'} className='social-icons'><FontAwesomeIcon icon={faYoutube}/></a>
              </div>
              </>
              )}
            </div>
            : <motion.div className='center-links nav'
            initial={{x: '-100%'}}
            animate={{x: 0}}
          >
            <button className='btn-close' onClick={() => toggleNav()}></button>
            <ul className='navlinks m-0'>
              <NavLink to="/" className='navlink active-nav' onClick={() => {
                  if(screenWidth < 1249){
                    toggleNav()
                  }
                }} >
                  <FontAwesomeIcon icon={faHouseChimney} className='me-2'/><span>Home</span>
              </NavLink>
              <NavLink to="/BM" className='navlink' onClick={() => {
                  if(screenWidth < 1249){
                    toggleNav()
                  }
                }}>
                  <FontAwesomeIcon icon={faBasketShopping} className='me-2'/><span>Black Market</span>
              </NavLink>
              <NavLink to="/RA" className='navlink' onClick={() => {
                  if(screenWidth < 1249){
                    toggleNav()
                  }
                }}>
                  <FontAwesomeIcon icon={faBasketShopping} className='me-2'/><span>Radiation Alliance</span>
              </NavLink>
              <NavLink to="/Support" className='navlink' onClick={() => {
                  if(screenWidth < 1249){
                    toggleNav()
                  }
                }}>
                  <FontAwesomeIcon icon={faHeadset} className='me-2'/><span>Support</span>
              </NavLink>
            </ul>
            <div className='lenguage'>
              <button className='btn-change-lenguage' style={{backgroundImage: "url(/img/usa-flag.png)"}}>
              </button>
            </div>
            {toggleMenu && (
              <>
                <hr
                    style={{
                        color: '#fff',
                        height: '1px',
                        width: '100%',
                    }}
                />
              <div className='d-flex align-content-center box-socials'>
              <a href="https://discord.gg/extinctionwars" target={'_blank'} className='social-icons me-3'><FontAwesomeIcon icon={faDiscord}/></a>
              <a href="https://twitter.com/ExtinctionWars" target={'_blank'}className='social-icons me-3'><FontAwesomeIcon icon={faTwitter}/></a>
              <a href="https://www.instagram.com/extinctionwars" target={'_blank'}className='social-icons me-3'><FontAwesomeIcon icon={faInstagram}/></a>
              <a href="https://t.me/WarsExtinction" target={'_blank'}className='social-icons me-3'><FontAwesomeIcon icon={faTelegram}/></a>
              <a href="https://www.youtube.com/channel/UCEQnnrtqR6bqQWXOtzyhLrQ" target={'_blank'} className='social-icons'><FontAwesomeIcon icon={faYoutube}/></a>
            </div>
            </>
            )}
          </motion.div>

            }
            <div className='bg-navtoggled' onClick={() => toggleNav()}></div>
          </div>
        )}
        <div className='ui-elements d-flex align-items-center'>
          <div className='notify_box'>
            {toggleNotify
              ? <button className='notify' onClick={() => toggleNot()}><FontAwesomeIcon icon={faBell} size='lg'/></button>
              : <button className='notify' onClick={() => toggleNot()}><FontAwesomeIcon icon={faFarBell} size='lg'/></button>

            }
          </div>
          <div className='accounts-nav d-flex align-items-center'>
            <FontAwesomeIcon icon={faUser} size='2x' className='i-user me-2' onClick={() => PushUrl('/profile')} style={{cursor: 'pointer'}}/>
            <div className='account-info'>
              <p className='m-0'>{userData.username}</p>
              <p data-tip={userData.userBalances.bFullWax} className='m-0 account-balance'>{userData.userBalances.bShortWax} WAXP</p>
              <p data-tip={userData.userBalances.bFullOnyx} className='m-0 account-balance'>{userData.userBalances.bShortOnyx} ONYX</p>
            </div>
            {userData.isConnected 
                ? <button className='btn-login' onClick={() => onLogout(userData.sessionData)}>Logout</button>
                : <button className='btn-login' onClick={onLogin}>Log In</button>
            }
            {toggleMenu
              ? <button className='btn-toggler-nav' onClick={() => toggleNav()}><FontAwesomeIcon icon={faBarsStaggered} size='lg'/></button>
              : <button className='btn-toggler-nav' onClick={() => toggleNav()}><FontAwesomeIcon icon={faBars} size='lg'/></button>
            }
          </div>
        </div>
        <ReactTooltip />
    </div>
  )
}
